<template>
    <transition name="fade" mode="out-in">
        <div class="panel-box" v-show="isShow">
            <template v-if="model === 'alert'">
                <transition name="bounce">
                    <div class="panel panel-alert" v-show="isShow">
                        <div class="panel-inner">
                            <div class="panel-content" data-max="16">
                                <slot>{{content}}</slot>
                            </div>
                            <div class="panel-footer">
                                <a class="panel-btnTrue" :href="btnTrueHref" @click.prevent="event_fnOk">
                                    {{btnTrueText}}
                                </a>
                            </div>
                        </div>
                    </div>
                </transition>
            </template>
            <template v-else-if="model === 'confirm'">
                <transition name="bounce">
                    <div class="panel panel-confirm" v-show="isShow">
                        <div class="panel-inner">
                            <div class="panel-content" data-max="16">
                                <slot>{{content}}</slot>
                            </div>
                            <div class="panel-footer">
                                <a class="panel-btnCancel" :href="btnCancelHref"  @click.prevent="event_fnCancel">
                                    {{btnCancelText}}
                                </a>
                                <a v-if="isJumpHref" class="panel-btnTrue" :href="btnTrueHref">
                                    <slot name="btnTrueText"></slot>
                                    {{btnTrueText}}
                                </a>
                                <a v-else class="panel-btnTrue" :href="btnTrueHref" @click.prevent="event_fnOk">
                                    <slot name="btnTrueText"></slot>
                                    {{btnTrueText}}
                                </a>
                            </div>
                        </div>
                    </div>
                </transition>
            </template>
            <template v-else-if="model === 'titleConfirm'">
                <transition name="bounce">
                    <div class="panel panel-titleConfirm" v-show="isShow">
                        <div class="panel-inner">
                            <div class="panel-title">
                                {{title}}
                            </div>
                            <div class="panel-content" data-max="16">
                                <slot>{{content}}</slot>
                            </div>
                            <div class="panel-footer">
                                <a class="panel-btnCancel" :href="btnCancelHref" @click.prevent="event_fnCancel">
                                    {{btnCancelText}}
                                </a>
                                <a class="panel-btnTrue" :href="btnTrueHref" @click.prevent="event_fnOk">
                                    {{btnTrueText}}
                                </a>
                            </div>
                        </div>
                    </div>
                </transition>
            </template>
        </div>
     </transition>
</template>
<script>
import { mapMutations } from 'vuex';

export default {
    name: "",
    props: {
        model: {
            type: String,
            default: 'alert'
        },
        isShow: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '提示'
        },
        content: {
            type: String,
            default: ''
        },
        btnCancelText: {
            type: String,
            default: '取消'
        },
        btnCancelHref: {
            type: String,
            default: 'javascript: void(0);'
        },
        btnTrueText: {
            type: String,
            default: '确定'
        },
        btnTrueHref: {
            type: String,
            default: 'javascript: void(0);'
        }
    },
    mounted: function(){

    },
    data: () => ({

    }),
    computed: {
        isJumpHref(){
            return this.btnTrueHref != 'javascript: void(0);';
        }
    },
    methods: {
        event_fnCancel(){
            this.$emit('emit_cancel');
            this.$emit('emit_close');
        },
        event_fnOk(){
            this.$emit('emit_ok');
            this.$emit('emit_close');
        },
        ...mapMutations({
            set_alert_hide: 'SET_ALERT_HIDE'
        })
    }
}
</script>
<style lang="scss" scoped>
.panel-box,
.panel {
    position: fixed;
}
.panel-box {
    -display: none;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 6000;
    background-color: rgba(0, 0, 0, 0.6);
}
.panel {
    top: 50%;
    right: toRem(100);
    left: toRem(100);
}
.panel-inner {
    overflow: hidden;
    @include border-radius(8px);
    @include transform(translate(0, -50%));
    background: #FFF;
}
.panel-title {
    font-size: toRem(30);
    text-align: center;
    color: #1A191E;
}
.panel-content {
    padding: toRem(58) toRem(50);
    border-bottom: 1px solid #ECECEC;
    font-size: toRem(28);
    line-height: toRem(40);
    text-align: center;
    color: #333;
}
.panel-footer {
    @extend %flex-horizontal;
    @include box-pack(justify);
    height: toRem(102);
    text-align: center;
    font-size: toRem(30);
    line-height: toRem(102);
    color: #1A191E;

    a {
        display: block;
        @include flex(1);
    }
}
//确认弹层
.panel-confirm {
    a {
        margin-left: -1px;
    }
    @at-root .panel-btnCancel {
        border-right: 1px solid #FFF;
    }
    @at-root .panel-btnTrue {
        border-left: 1px solid #ECECEC;
    }
}
.panel-titleConfirm {
    .panel-title {
        padding: toRem(54) 0 0;
    }
    .panel-content {
        padding: toRem(24) toRem(50) toRem(48);
        -text-align: left;
    }
}
.hide {
    opacity: 0;
}
.tl {
    text-align: left;
}
.tc {
    text-align: center;
}

.fade-enter-active, .fade-leave-active {
    transition: background-color .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    background-color: rgba(0, 0, 0, 0);
}
.bounce-enter-active {
  animation: bounce .15s cubic-bezier(0.25, 0.1, 0.76, 1.38);
}
.bounce-leave-active {
  animation: bounce .15s cubic-bezier(0.25, 0.1, 0.76, 1.38) reverse;
}

@keyframes -webkit-bounce {
    0% {
        opacity: 0;
        -webkit-transform: scale(0.7) translateZ(0);
        transform: scale(0.7) translateZ(0);
    }
    100%{
        opacity: 1;
        -webkit-transform: scale(1) translateZ(0);
        transform: scale(1) translateZ(0);
    }
}
@keyframes bounce {
    0% {
        opacity: 0;
        -webkit-transform: scale(0.7) translateZ(0);
        transform: scale(0.7) translateZ(0);
    }
    100%{
        opacity: 1;
        -webkit-transform: scale(1) translateZ(0);
        transform: scale(1) translateZ(0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/MDialog/index.vue